import { gql } from 'graphql.macro';

export const assistantConversationsTemplate = gql`
    query assistantConversations {
        assistantConversations {
            _id
            title
            messageCount
            updatedAt
        }
    }
`;

export const assistantConversationTemplate = gql`
    query assistantConversation($id: String!) {
        assistantConversation(id: $id) {
            _id
            title
            createdAt
            messages {
                role
                text
                articleLinks {
                    articleId
                    title
                }
            }
        }
    }
`;
